import React, { Component, Fragment } from 'react';
import MetaTags from "react-meta-tags";
import Breadcrumb from "../layouts/Breadcrumb";
import Header from '../layouts/Headerthree';
import Footer from '../layouts/Footerthree';
import Content from '../sections/Services/Content';

class Services extends Component {
    render() {
        return (
            <Fragment>
                <MetaTags>
                    <title>Onitir | Services</title>
                    <meta
                        name="description"
                        content="#"
                    />
                </MetaTags>
                <Header />
                <Breadcrumb breadcrumb={{pagename:'Services'}} />
                <Content/>
                <Footer />
            </Fragment>
        );
    }
}

export default Services;